import { Component, Input, ChangeDetectionStrategy, HostBinding, ChangeDetectorRef } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-titan-menu-popover',
  templateUrl: './titan-menu-popover.component.html',
  styleUrls: ['./titan-menu-popover.component.scss'],
  standalone: true,
  imports: [NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitanMenuPopoverComponent {
  @Input() className: string = '';
  @Input() dataTrigger: string = '';
  @Input() placement: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' | 'bottom' | 'top' | 'left' | 'right' = 'bottom-right';
  
  private _isOpen: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  get isOpen(): boolean {
    return this._isOpen;
  }

  set isOpen(value: boolean) {
    this._isOpen = value;
    this.cdr.markForCheck();
  }

  get popoverClasses(): string {
    return `popover ${this.className}`.trim();
  }

  get sanitizedDataTrigger(): string | null {
    return this.dataTrigger.trim() || null;
  }

  @HostBinding('attr.data-placement')
  get dataPlacement(): string {
    return this.placement;
  }
}
